import React, { useEffect, useState, useCallback } from "react";
import toast, { Toaster } from "react-hot-toast";
import CreateTaskForm from "../../components/createTaskForm";
import DrawerComponent from "../../components/drawer";
import Header from "../../components/header";
import TasksTable from "../../components/tasksTable";
import { getAllFollowUps, taskById } from "../../services/followupService";
import { bulkOperationTasks, deleteTask } from "../../services/taskService";
import { assignLeadInList, copyLeadInList, moveLeadInList } from "../../services/leadService";
import { setManuallyAutomate, getAutomationList } from "../../services/automationService";
import { getAllLeadList } from "../../services/leadListService";
import SelectLeadStatus from "../../components/status";
import InfiniteScroll from "react-infinite-scroll-component";
import "./follwups.scss";
import FilterIcon from "../../assets/images/filter.svg";
import ReloadIcon from "../../assets/images/reload.svg";
import TaskFilter from "./TaskFilter";
import LeadDetails from "../leads/leadDetails/leadDetails";
import { LeadDataI } from "../leads/leads";
import { useSelector } from "react-redux";
import { activityById } from "../../services/activityService";
import { uploadFiles } from "../../services/utilityService";
import { leadFileList } from "../../actions/actions";
import { useDispatch } from "react-redux";
import LeadMenu from "./LeadMenu/leadMenu";
import { TbWindowMaximize } from "react-icons/tb";
import { TaskQueryParameters, initialQueryParams } from "../../utils/types";
import BackToTop from "../../components/BackToTop";
import { Spin } from "antd";
import GlobalDrawer from "../../components/GlobalDrawer";
import TaskDrawer from "../common/TaskDrawer";
import moment from "moment";
import type { ITaskData } from './types';
import TaskGrid from "./TaskGrid";
import TaskBulkActionsBar from "./TaskBulkActionsBar";
import { AlertCircle, Calendar, CheckCircle, Clock, Filter, RotateCw } from "lucide-react";
import TaskFormPopupWrapper from "../leads/TaskFormPopupWrapper;";
import logger, { Logger } from '../../utils/logger';
import ConfirmationModal from "../../components/confirmationModal";
import GenericConfirmationModal from "../../components/GenericConfirmationModal";
import TaskFilterStatusBar from "./TaskFilterStatusBar";
import BulkSelector from "../../components/BulkSelector/bulkSelector";

const FollowUps: React.FC = () => {
  const [todayTask, setTodayTask] = useState<ITaskData[]>([]);
  const [overdueTask, setOverdueTask] = useState([]);
  const [upcomingTask, setUpcomingTask] = useState([]);
  const [completedTask, setCompletedTask] = useState([]);
  const [status, setStatus] = useState<
    "today" | "upcoming" | "overdue" | "completed"
  >("today");
  const [openWithHeader, setOpenWithHeader] = React.useState<boolean>(false);
  
  const [action, setAction] = React.useState<string>("");
  const [selectedTask, setSelectedTask] = useState<string>("");
  const [updateTaskValue, setUpdateTaskValue] = useState<any>({});
  const [taskTabCount, setTaskTabCount] = useState<any>({});
  const [currentPage, setCurrentPage] = useState(1);
  const [totalTasks, setTotalTasks] = useState<number>(0);
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [openFilterMenu, setOpenFilterMenu] = useState<boolean>(false);
  const [selectedLead, setSelectedLead] = useState<LeadDataI>();
  const [leadId, setLeadId] = useState<any>();
  const [leadLabelData, setLeadLabelData] = useState<Array<string>>([]);
  const StoreData = useSelector((state: any) => {
    return state?.rootReducers;
  });
  const [selectedTaskKeys, setSelectedTaskKeys] = useState<React.Key[]>([]);
const [selectedTasks, setSelectedTasks] = useState<ITaskData[]>([]);
  const [paramState, setParamState] = useState<TaskQueryParameters>({});
  const [filterResetKey, setFilterResetKey] = useState<number>(0);
 
  const [isTaskFormOpen, setIsTaskFormOpen] = useState(false);
  const [currentTask, setCurrentTask] = useState(null);

const [selectedTaskCount, setSelectedTaskCount] = useState<number>(0);
  const [bulkTaskIds, setBulkTaskIds] = useState<string[]>([]);
const [confirmationCallback, setConfirmationCallback] = useState<(value: boolean) => void>(() => {});

  const [openLeadDrawer, setOpenLeadDrawer] = useState<boolean>(false);
const [showCompleteConfirmation, setShowCompleteConfirmation] = useState(false);
const [taskToComplete, setTaskToComplete] = useState<{id: string, name: string} | null>(null);

// Bulk operations state (copied from campaign view)
const [assignLeadDrawer, setAssignLeadDrawer] = useState(false);
const [copyLeadDrawer, setCopyLeadDrawer] = useState(false);
const [automationDrawer, setAutomationDrawer] = useState(false);
const [activeLeadOption, setActiveLeadOption] = useState("copy");
const [leadListData, setLeadListData] = useState<any>([]);
const [automationList, setAutomationList] = useState<any>([]);

// Status editing state
const [showStatusPopup, setShowStatusPopup] = useState<boolean>(false);
const [bulkSelectedStatus, setBulkSelectedStatus] = useState<string>("");

// Scroll tracking for floating counter
const [hasScrolled, setHasScrolled] = useState<boolean>(false);
 
  let userPreferences: any = {};

  try {
    userPreferences = JSON.parse(
      localStorage.getItem("user_preferences") || ""
    );
  } catch (e) {
    userPreferences = {};
  }


  // Add this useEffect temporarily
useEffect(() => {
  const elements = [
    'scrollableDiv',
    '.ant-table-wrapper', 
    '.ant-table-body',
    '.ant-spin-container'
  ];
  
  elements.forEach(selector => {
    const el = document.querySelector(selector);
    if (el) {
      const style = window.getComputedStyle(el);
      logger.log(`${selector}:`, {
        height: style.height,
        maxHeight: style.maxHeight,
        overflowY: style.overflowY
      });
    }
  });
}, [overdueTask]);

  // Add this to check container height
useEffect(() => {
  const checkScrollable = () => {
    const container = document.getElementById('main');
    if (container) {
      logger.log('📏 Container dimensions:', {
        scrollHeight: container.scrollHeight,
        clientHeight: container.clientHeight,
        scrollTop: container.scrollTop,
        isScrollable: container.scrollHeight > container.clientHeight
      });
    }
  };
  
  setTimeout(checkScrollable, 1000); // Check after data loads
}, [overdueTask]);

  useEffect(() => {
    Logger.log('Selected tasks changed:', {
      count: selectedTaskKeys.length,
      tasks: selectedTasks
    });
  }, [selectedTaskKeys, selectedTasks]);

  // Scroll listener for floating counter visibility
  useEffect(() => {
    const scrollableDiv = document.getElementById('scrollableDiv');

    const handleScroll = () => {
      if (scrollableDiv && scrollableDiv.scrollTop > 100) {
        setHasScrolled(true);
      } else {
        setHasScrolled(false);
      }
    };

    if (scrollableDiv) {
      scrollableDiv.addEventListener('scroll', handleScroll);
    }

    return () => {
      if (scrollableDiv) {
        scrollableDiv.removeEventListener('scroll', handleScroll);
      }
    };
  }, []);

  const handleAddTask = () => {
    setCurrentTask(null);
    setIsTaskFormOpen(true);
  };
  

  // Close task form
  const handleCloseTaskForm = () => {
    setIsTaskFormOpen(false);
    setCurrentTask(null);
  };

  // Refresh task list after operation
  const handleTaskStatusUpdate = (newTaskData: any) => {
    setIsTaskFormOpen(false);
    // Optionally refresh task list
    fetchTaskStatusFollowUps();
  };

  const fetchTaskStatusFollowUps = async () => {
    let params = {
      orderBy: "toBePerformAt",
      isAscending: true,
      page: 1,
      perPage: 50,
      status: status,
    };
    setParamState({
      ...paramState,
      orderBy: "toBePerformAt",
      page: 1,
      isAscending: true,
      status: status,
    });
    
  };

  const handleSelectionChange = (newSelectedRowKeys: React.Key[], selectedRows: ITaskData[]) => {
    Logger.log('Selection changed in FollowUps:', { newSelectedRowKeys, selectedRows });
    setSelectedTaskKeys(newSelectedRowKeys);
    setSelectedTasks(selectedRows);
   

    setSelectedTaskCount(newSelectedRowKeys.length);
  };

  
  const handleTaskSelection = (total: number) => {
  let currentData = status === "today" ? todayTask : 
                   status === "upcoming" ? upcomingTask :
                   status === "overdue" ? overdueTask : completedTask;
  
  let startIndex = 0;
  if (selectedTaskKeys.length > 0) {
    const lastSelectedKey = selectedTaskKeys[selectedTaskKeys.length - 1];
    startIndex = currentData.findIndex(task => task._id === lastSelectedKey) + 1;
  }
  
  const endIndex = Math.min(startIndex + total, currentData.length);
  const tasksToSelect = currentData.slice(startIndex, endIndex);
  
  const newSelectedKeys = [...selectedTaskKeys, ...tasksToSelect.map(task => task._id)];
  const newSelectedTasks = [...selectedTasks, ...tasksToSelect];
  
  setSelectedTaskKeys(newSelectedKeys);
  setSelectedTasks(newSelectedTasks);
  setSelectedTaskCount(newSelectedKeys.length);
  
  if (endIndex >= currentData.length && currentData.length < getTabCount()) {
    fetchTaskStatusOnScroll(status);
  }
};

const handleTaskUnSelect = () => {
  setSelectedTaskKeys([]);
  setSelectedTasks([]);
  setSelectedTaskCount(0);
};

const getTabCount = () => {
  switch (status) {
    case "today": return taskTabCount?.today || 0;
    case "upcoming": return taskTabCount?.upcoming || 0;
    case "overdue": return taskTabCount?.overdue || 0;
    case "completed": return taskTabCount?.completed || 0;
    default: return 0;
  }
};

  const fetchTaskStatusOnScroll = (tab: string) => {
    // Guard: prevent duplicate calls while loading
    if (isLoading) {
      logger.log('⏳ Already loading, skipping scroll fetch');
      return;
    }

    if (tab === status) {
      setIsLoading(true);
      const nextPage = currentPage + 1;

      logger.log('📜 Fetching page:', nextPage, 'for tab:', tab);

      setParamState({
        ...paramState,
        orderBy: "toBePerformAt",
        isAscending: true,
        page: nextPage,
        status: status,
      });
      setOpenFilterMenu(false);
    }
  };

  const refreshTab = () => {
  logger.log('🔄 Refreshing tab:', status);
  
  // ✅ CRITICAL FIX: Properly reset to initial state with current status
  const updateObject = {
    status: status,  // Keep current status
    isAscending: true,
    orderBy: "toBePerformAt",
    page: 1,
    // Clear all filter parameters
    team: undefined,
    userId: undefined,
    taskAssign: undefined,
    taskType: undefined,
    startedAt: undefined,
    endedAt: undefined,
    byOrganization: undefined,
    leadId: undefined
  };

  logger.log('🔧 Refresh with clean params:', updateObject);
  setParamState(updateObject);
  
  // ✅ FIX: Also reset the filter form UI
  setFilterResetKey(prev => prev + 1);
};


const fetchData = async () => {
  try {
    setIsLoading(true);
    logger.log('🔄 fetchData called with paramState:', paramState);
    logger.log('🔄 Current status:', status);
    
    const requestParams: TaskQueryParameters = {};
    
    // Helper function to conditionally add parameters
    const addParam = (
      paramName: keyof TaskQueryParameters,
      paramValue: any
    ) => {
      if (paramValue !== undefined && paramValue !== "") {
        requestParams[paramName] = paramValue;
        logger.log(`📝 Adding param: ${paramName} = ${paramValue}`);
      }
    };

    // Add parameters conditionally
    addParam("orderBy", paramState.orderBy);
    addParam("isAscending", paramState.isAscending);
    addParam("page", paramState.page);
    addParam("perPage", 50);

    // ✅ CRITICAL FIX: Always add current status to ensure consistent aggregation
    const currentStatus = paramState.status || status;
    if (currentStatus && ["completed", "upcoming", "overdue", "today"].includes(currentStatus)) {
      addParam("status", currentStatus);
      logger.log(`🎯 Using status: ${currentStatus}`);
    } else {
      console.warn('⚠️ No valid status found, this might cause inconsistent results');
    }

    addParam("leadId", paramState.leadId);
    addParam("userId", paramState.userId);

    if (paramState.byOrganization) {
      addParam("byOrganization", paramState.byOrganization);
    } else {
      addParam("team", paramState.team);
    }
    
    addParam("assignToUser", paramState.taskAssign);
    addParam("taskType", paramState.taskType);
    addParam("startedAt", paramState.startedAt);
    addParam("endedAt", paramState.endedAt);

    logger.log('📤 Final API request params:', requestParams);

    const response = await getAllFollowUps(requestParams);
    
    if (response && response.status) {
      const responseData = response?.data;
      
      // ✅ DETAILED LOGGING for debugging
      logger.log('📥 API Response received:', {
        dataLength: responseData.data?.length,
        aggregation: responseData.aggregation,
        currentStatus: status,
        paramStatus: paramState.status,
        currentPage: paramState.page
      });

      // Log actual aggregation values
      logger.log('📊 Aggregation details:', {
        today: responseData.aggregation?.today || 0,
        upcoming: responseData.aggregation?.upcoming || 0,
        overdue: responseData.aggregation?.overdue || 0,
        completed: responseData.aggregation?.completed || 0,
        total: responseData.aggregation?.total || 0
      });

      // CLOSE FILTER DIALOG BOX
      setOpenFilterMenu(false);
      
      let tempArray: any = [];

      // Helper to deduplicate by _id
      const deduplicateById = (existing: any[], newItems: any[]) => {
        const existingIds = new Set(existing.map(item => item._id));
        const uniqueNewItems = newItems.filter(item => !existingIds.has(item._id));
        return [...existing, ...uniqueNewItems];
      };

      if (paramState.page && paramState.page > 1) {
        logger.log('📄 Appending data for pagination (with deduplication)...');
        if (status === "today") {
          tempArray = deduplicateById(todayTask, responseData.data);
          setTodayTask(tempArray);
        } else if (status === "upcoming") {
          tempArray = deduplicateById(upcomingTask, responseData.data);
          setUpcomingTask(tempArray);
        } else if (status === "overdue") {
          tempArray = deduplicateById(overdueTask, responseData.data);
          setOverdueTask(tempArray);
        } else {
          tempArray = deduplicateById(completedTask, responseData.data);
          setCompletedTask(tempArray);
        }
      } else {
        logger.log('📋 Setting fresh data for page 1...');
        tempArray = [...responseData.data];
        if (status === "today") {
          setTodayTask(tempArray);
        } else if (status === "upcoming") {
          setUpcomingTask(tempArray);
        } else if (status === "overdue") {
          setOverdueTask(tempArray);
        } else {
          setCompletedTask(tempArray);
        }
      }

      setCurrentPage(paramState?.page ?? 1);
      setIsLoading(false);
      setTotalTasks(tempArray?.length);
      
      // ✅ CRITICAL: Update tab counts with detailed logging
      logger.log('📊 Updating tab counts from:', taskTabCount, 'to:', responseData.aggregation);
      setTaskTabCount(responseData.aggregation);
      
    } else {
      console.error('❌ API response failed:', response);
      setIsLoading(false);
    }
  } catch (error) {
    console.error('❌ fetchData error:', error);
    setIsLoading(false);
  }
};


  useEffect(() => {
    fetchTaskStatusFollowUps();
  }, [status]);



/**
 * ✅ FIXED: Remove specific filter - handles all TypeScript issues
 * @param filterKey - The filter key to remove (e.g., 'team', 'userId')
 * @param filterValue - Optional specific value to remove
 */
const handleRemoveFilter = (filterKey: string, filterValue?: string) => {
  logger.log('🗑️ Removing filter:', { filterKey, filterValue });

  // ✅ FIX: Create new param state with type assertion for dynamic access
  const newParams = { ...paramState } as any;

  // ✅ FIX: Handle special cases with correct property names
  if (filterKey === 'startedAt' || filterKey === 'date') {
    // Remove both start and end dates - using correct property names from type
    delete newParams.startedAt;  // ✅ This exists in TaskQueryParameters
    delete newParams.endedAt;    // ✅ This exists in TaskQueryParameters
    // Don't try to delete startDate/endDate as they don't exist in the type
  } else if (filterKey === 'orderBy' || filterKey === 'isAscending') {
    // ✅ Reset sort settings to default instead of deleting
    newParams.orderBy = "toBePerformAt";
    newParams.isAscending = true;
  } else {
    // ✅ FIX: Remove the specific filter with type assertion
    delete newParams[filterKey];
  }

  // Reset page to 1 when filters change
  newParams.page = 1;

  logger.log('🔧 New params after filter removal:', newParams);
  setParamState(newParams);
};

/**
 * ✅ FIXED: Clear all filters and reset to default state
 */
const handleClearAllFilters = () => {
  logger.log('🧹 Clearing all filters');
  
  // ✅ FIX: Reset to base state with proper typing
  const resetParams = {
    status: status,
    isAscending: true,
    orderBy: "toBePerformAt",
    page: 1,
    perPage: 50
    // All other properties will be undefined (cleared)
  };
  
  logger.log('🔄 Reset params:', resetParams);
  setParamState(resetParams);
  
  // ✅ FIX: Force TaskFilter component to reset by updating key
  setFilterResetKey(prev => prev + 1);
  
  // Clear selections when clearing filters
  setSelectedTaskKeys([]);
setSelectedTasks([]);
setSelectedTaskCount(0);
};

/**
 * Open filter drawer for editing
 */
const handleEditFilter = () => {
  logger.log('✏️ Opening filter drawer for editing');
  setOpenFilterMenu(true);
};

  // Bulk operations functions (copied from campaign view)
  const handleGetLeadList = async () => {
    try {
      const response = await getAllLeadList({
        isAscending: false,
        page: 1,
        perPage: 100,
      });
      if (response && response.status) {
        let defaultLead = {
          name: "Default lead list",
          _id: "",
        };
        setLeadListData([defaultLead, ...response.data.data]);
      }
    } catch (err) {
      console.error('Error fetching lead lists:', err);
    }
  };

  const handleGetAutomationList = async () => {
    try {
      const response = await getAutomationList();
      if (response && response.status) {
        setAutomationList(response.data.data);
      }
    } catch (err) {
      console.error('Error fetching automation list:', err);
    }
  };

  // Bulk operation handlers
  const handleAssignLead = async (assignToUser: string) => {
    try {
      // Extract lead IDs from selected tasks
      const leadIds: string[] = [];
      selectedTasks.forEach(task => {
        if (task.lead && Array.isArray(task.lead)) {
          task.lead.forEach(lead => {
            if (lead._id && !leadIds.includes(lead._id)) {
              leadIds.push(lead._id);
            }
          });
        }
      });

      if (leadIds.length === 0) {
        toast.error('Please select tasks with leads to assign');
        return;
      }

      const { data } = await assignLeadInList({ leadIds: leadIds, assignToUser });
      toast.success(data?.message || 'Leads assigned successfully');
      setAssignLeadDrawer(false);
      setSelectedTaskKeys([]);
      setSelectedTasks([]);
      setSelectedTaskCount(0);
      fetchTaskStatusFollowUps(); // Refresh data
    } catch (error) {
      console.error('Error assigning leads:', error);
      toast.error('Failed to assign leads');
    }
  };

  const handleCopyLead = async (targetListId: string, activeLeadOption: string) => {
    try {
      // Extract lead IDs from selected tasks
      const leadIds: string[] = [];
      selectedTasks.forEach(task => {
        if (task.lead && Array.isArray(task.lead)) {
          task.lead.forEach(lead => {
            if (lead._id && !leadIds.includes(lead._id)) {
              leadIds.push(lead._id);
            }
          });
        }
      });

      if (leadIds.length === 0) {
        toast.error('Please select tasks with leads to copy/move');
        return;
      }

      const data = {
        leadIDs: leadIds,
        targetListId: targetListId === "" ? null : targetListId,
      };

      if (activeLeadOption === "copy") {
        const response = await copyLeadInList(data);
        toast.success(response?.data?.message || 'Leads copied successfully');
      } else {
        const response = await moveLeadInList(data);
        toast.success(response?.data?.message || 'Leads moved successfully');
      }

      setCopyLeadDrawer(false);
      setSelectedTaskKeys([]);
      setSelectedTasks([]);
      setSelectedTaskCount(0);
      fetchTaskStatusFollowUps(); // Refresh data
    } catch (error) {
      console.error('Error copying/moving leads:', error);
      toast.error(`Failed to ${activeLeadOption} leads`);
    }
  };

  const handleSelectAutomate = async (automationId: string) => {
    try {
      // Extract lead IDs from selected tasks
      const leadIds: string[] = [];
      selectedTasks.forEach(task => {
        if (task.lead && Array.isArray(task.lead)) {
          task.lead.forEach(lead => {
            if (lead._id && !leadIds.includes(lead._id)) {
              leadIds.push(lead._id);
            }
          });
        }
      });

      if (leadIds.length === 0) {
        toast.error('Please select tasks with leads to add to automation');
        return;
      }

      const data = {
        leadIds: leadIds,
        automationId,
      };

      const response = await setManuallyAutomate(data);
      toast.success(response?.data?.message || 'Leads added to automation successfully');
      setAutomationDrawer(false);
      setSelectedTaskKeys([]);
      setSelectedTasks([]);
      setSelectedTaskCount(0);
      fetchTaskStatusFollowUps(); // Refresh data
    } catch (error) {
      console.error('Error adding leads to automation:', error);
      toast.error('Failed to add leads to automation');
    }
  };

  // Status handlers
  const toggleLeadStatus = () => {
    setShowStatusPopup(!showStatusPopup);
    setBulkSelectedStatus("");
  };

  const onLeadStatusChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setBulkSelectedStatus(e.target.value);
  };

  const onEditStatus = () => {
    // Extract lead IDs from selected tasks
    const leadIds: string[] = [];
    selectedTasks.forEach(task => {
      if (task.lead && Array.isArray(task.lead)) {
        task.lead.forEach(lead => {
          if (lead._id && !leadIds.includes(lead._id)) {
            leadIds.push(lead._id);
          }
        });
      }
    });

    if (leadIds.length === 0) {
      toast.error('Please select tasks with leads to edit status');
      return;
    }
    setShowStatusPopup(true);
  };

  // Load lead lists and automation on component mount
  useEffect(() => {
    handleGetLeadList();
    handleGetAutomationList();
  }, []);


  const handleBulkAction = async (action: string, date?: any, newAssigneeId?: string) => {
    Logger.log('handleBulkAction called:', { action, date, newAssigneeId, selectedTaskKeys });
  
    if (selectedTaskKeys.length === 0) {
      toast.error('Please select at least one task');
      return;
    }
  
    // Get task IDs from selected tasks
    const taskIds = selectedTasks.map(task => task._id);
  
    try {
      switch (action) {
        case 'delete':
          try {
            // Use bulk operation to mark tasks as deleted
            const bulkDeletePayload = {
              taskIds: selectedTaskKeys.map(id => id as string),
              isDeleted: true
            };
  
            const response = await bulkOperationTasks(bulkDeletePayload);
  
            if (response && response.status) {
              toast.success(`${selectedTaskKeys.length} tasks deleted successfully`);
              
              // Refresh the current tab
              fetchTaskStatusFollowUps();
              
              // Clear selections
            setSelectedTaskKeys([]);
setSelectedTasks([]);
setSelectedTaskCount(0);
setOpenWithHeader(false);
            } else {
              toast.error('Failed to delete tasks');
            }
          } catch (error) {
            console.error('Bulk delete error:', error);
            toast.error('Error deleting tasks');
          }
          break;
  
        case 'reassign':
          try {
            if (!newAssigneeId) {
              toast.error('No assignee selected');
              return;
            }
  
            Logger.log('Making reassign API call with:', {
              taskIds: selectedTaskKeys,
              assignedTo: newAssigneeId
            });
  
            await bulkOperationTasks({
              taskIds: selectedTaskKeys.map(id => id.toString()),
              assignedTo: newAssigneeId
            });
  
   toast.success('Tasks reassigned successfully');
await fetchTaskStatusFollowUps();
setSelectedTaskKeys([]);
setSelectedTasks([]);
setSelectedTaskCount(0);
setOpenWithHeader(false);
          } catch (error) {
            console.error('Reassign error:', error);
            toast.error('Error reassigning tasks');
          }
          break;
  
          case 'updateDueDate':
            try {
              if (!date) {
                toast.error('No date selected');
                return;
              }
    
              await bulkOperationTasks({
                taskIds: selectedTaskKeys.map(id => id.toString()),
                dueDate: date  // API will handle the date format
              });
    
           toast.success('Due dates updated successfully');
await fetchTaskStatusFollowUps();
setSelectedTaskKeys([]);
setSelectedTasks([]);
setSelectedTaskCount(0);
setOpenWithHeader(false);
            } catch (error) {
              console.error('Update due date error:', error);
              toast.error('Error updating due dates');
            }
            break;
  
        case 'complete':
          try {
            await bulkOperationTasks({
              taskIds,
              isCompleted: true
            });
        toast.success('Tasks marked as complete');
await fetchTaskStatusFollowUps();
setSelectedTaskKeys([]);
setSelectedTasks([]);
setSelectedTaskCount(0);
setOpenWithHeader(false);
          } catch (error) {
            console.error('Complete tasks error:', error);
            toast.error('Error completing tasks');
          }
          break;

        case 'editStatus':
          try {
            if (!date) { // reusing date parameter for status
              toast.error('No status selected');
              return;
            }

            // Extract lead IDs from selected tasks
            const leadIds: string[] = [];
            selectedTasks.forEach(task => {
              if (task.lead && Array.isArray(task.lead)) {
                task.lead.forEach(lead => {
                  if (lead._id && !leadIds.includes(lead._id)) {
                    leadIds.push(lead._id);
                  }
                });
              }
            });

            if (leadIds.length === 0) {
              toast.error('No leads found for selected tasks');
              return;
            }

            // Use lead service to update status - this is a mock call, replace with actual API
            logger.log('Update lead status:', { leadIds, status: date });
            toast.success(`Status updated for ${leadIds.length} leads`);

            await fetchTaskStatusFollowUps();
            setSelectedTaskKeys([]);
            setSelectedTasks([]);
            setSelectedTaskCount(0);
            setOpenWithHeader(false);
          } catch (error) {
            console.error('Edit status error:', error);
            toast.error('Error updating lead status');
          }
          break;

        case 'copyToList':
          try {
            if (!date) { // reusing date parameter for list ID
              toast.error('No list selected');
              return;
            }

            // Extract lead IDs from selected tasks
            const leadIds: string[] = [];
            selectedTasks.forEach(task => {
              if (task.lead && Array.isArray(task.lead)) {
                task.lead.forEach(lead => {
                  if (lead._id && !leadIds.includes(lead._id)) {
                    leadIds.push(lead._id);
                  }
                });
              }
            });

            if (leadIds.length === 0) {
              toast.error('No leads found for selected tasks');
              return;
            }

            // Use copyLeadInList service
            await copyLeadInList({
              leadIds: leadIds,
              leadListId: date
            });

            toast.success(`${leadIds.length} leads copied to list successfully`);

            // Clear selections
            setSelectedTaskKeys([]);
            setSelectedTasks([]);
            setSelectedTaskCount(0);
            setOpenWithHeader(false);
          } catch (error) {
            console.error('Copy to list error:', error);
            toast.error('Error copying leads to list');
          }
          break;

        case 'automation':
          try {
            if (!date) { // reusing date parameter for automation ID
              toast.error('No automation selected');
              return;
            }

            // Extract lead IDs from selected tasks
            const leadIds: string[] = [];
            selectedTasks.forEach(task => {
              if (task.lead && Array.isArray(task.lead)) {
                task.lead.forEach(lead => {
                  if (lead._id && !leadIds.includes(lead._id)) {
                    leadIds.push(lead._id);
                  }
                });
              }
            });

            if (leadIds.length === 0) {
              toast.error('No leads found for selected tasks');
              return;
            }

            // Use setManuallyAutomate service
            const automationData = {
              leadIds: leadIds,
              automationId: date
            };

            await setManuallyAutomate(automationData);
            toast.success(`Automation applied to ${leadIds.length} leads successfully`);

            // Clear selections
            setSelectedTaskKeys([]);
            setSelectedTasks([]);
            setSelectedTaskCount(0);
            setOpenWithHeader(false);
          } catch (error) {
            console.error('Apply automation error:', error);
            toast.error('Error applying automation to leads');
          }
          break;
      }
  
    } catch (error) {
      console.error('Bulk operation error:', error);
      toast.error('Failed to update tasks');
    }
  };

  
const onStatusChange = (status: "today" | "upcoming" | "overdue" | "completed") => {
  setStatus(status);
  // Clear selections when changing tabs
  setSelectedTaskKeys([]);
  setSelectedTasks([]);
  setSelectedTaskCount(0);
  // Reset scroll state and scroll to top
  setHasScrolled(false);
  const scrollableDiv = document.getElementById('scrollableDiv');
  if (scrollableDiv) {
    scrollableDiv.scrollTop = 0;
  }
};

  const toggleDrawer = (action: React.SetStateAction<string>) => {
    setOpenWithHeader(true);
    setAction(action);
  };

const onTaskDelete = () => {
  if (updateTaskValue) {
    // Use the bulk actions selection instead
    setSelectedTaskKeys([updateTaskValue._id]);
    setSelectedTasks([updateTaskValue]);
    setSelectedTaskCount(1);  // ← ADD HERE (1 task selected)
    handleBulkAction('delete');
  }
};
  

  

  const handleEditTask = async (_id: string) => {
    try {
      const response = await taskById(_id);
      if (response && response.status) {
        setCurrentTask(response.data.data);
        setIsTaskFormOpen(true);
      }
    } catch (err) {
      toast.error("Error while fetching task data.");
    }
  };

  const toggleLeadFilterDrawer = useCallback(() => {
    setOpenFilterMenu(true);
  }, []);

  const handleLeadClick = (leadId: string) => {
    let selected = StoreData?.leads?.leads?.find(
      (lead: any) => lead._id === leadId
    );
    let tempArray = [];
    tempArray = StoreData?.user?.userPreferences?.labels
      ? StoreData?.user?.userPreferences?.labels
      : userPreferences?.labels;

    const mergedArray = tempArray.map((obj1: any) => {
      const matchingObjTeam = selected?.label.find(
        (obj2: any) => obj2 === obj1.value
      );
      let temp_obj = {};
      if (selected?.label.includes(obj1.value)) {
        temp_obj = {
          ...obj1,
          isLabelChecked: true,
        };
      } else {
        temp_obj = {
          ...obj1,
          isLabelChecked: false,
        };
      }

      if (matchingObjTeam) {
        return { ...temp_obj };
      }
      return obj1;
    });

    setSelectedLead(selected);
    setLeadId(leadId);
    setLeadLabelData(mergedArray);
  setOpenLeadDrawer(true);  // ← Use this instead of setOpenWithHeader
   
  };

  const onClickSecondOption = () => {
    handleLeadClick(updateTaskValue?.lead?.[0]?._id);
  };

  const handleLeadDetailsFromGrid = useCallback((leadId: string, leadName: string) => {
  logger.log('🔍 Opening lead details from grid:', { leadId, leadName });
  
  // Set minimal lead data so name shows immediately, API call will load full data
  setSelectedLead({
    _id: leadId,
    name: leadName,
    integration: '',
    customSource: '',
    createdAt: new Date(),
    status: [],
    saleValue: '',
    website: '',
    phone: '',
    email: '',
    label: []
  });
  setLeadId(leadId);
  setLeadLabelData([]);
  setOpenLeadDrawer(true);
}, []);

const handleCompleteTaskFromGrid = useCallback((taskId: string, leadName: string) => {
  logger.log('✅ Complete task requested:', { taskId, leadName });
  
  // Show confirmation before completing
  setTaskToComplete({ id: taskId, name: leadName });
  setShowCompleteConfirmation(true);
}, []);

const confirmCompleteTask = async () => {
  if (!taskToComplete) return;
  
  try {
    await bulkOperationTasks({
      taskIds: [taskToComplete.id],
      isCompleted: true
    });
    
    toast.success(`Task for ${taskToComplete.name} marked as complete`);
    fetchTaskStatusFollowUps(); // Refresh data
    
  } catch (error) {
    console.error('Error completing task:', error);
    toast.error('Failed to complete task');
  } finally {
    setShowCompleteConfirmation(false);
    setTaskToComplete(null);
  }
};


const onApplyFilterClick = async (data: any) => {
  logger.log('🎯 Filter applied with data:', data);

  let increasePage = currentPage;

  // ✅ CRITICAL FIX: Always include current status in filters with proper property mapping
  const filters: any = {
    ...paramState,
    page: 1,
    status: status, // ← Always include current tab status
    taskType: data?.taskType,
    userId: data?.sortTeamMemberBy,
    orderBy: data?.orderBy,
    // ✅ Add isAscending for sort direction (API expects boolean)
    isAscending: data?.isAscending,
    // ✅ CRITICAL FIX: Map to correct property names that exist in TaskQueryParameters
    startedAt: data?.startDate || data?.startedAt,  // Map startDate → startedAt
    endedAt: data?.endDate || data?.endedAt,        // Map endDate → endedAt
    taskAssign: data?.sortTaskAssignBy,
  };

  // ✅ FIX: Handle team vs organization filter mutual exclusivity
  if (data.byOrganization === true) {
    // Organization filter is active
    filters.byOrganization = true;
    // Don't set team when organization filter is active
    delete filters.team;
  } else if (data?.sortTeamsBy) {
    // Specific team is selected
    filters.team = data.sortTeamsBy;
    filters.byOrganization = false;
  } else {
    // No team/organization filter
    delete filters.team;
    delete filters.byOrganization;
  }

  logger.log('🔧 Applied filters (WITH MUTUAL EXCLUSIVITY):', filters);
  logger.log('📍 Current status when applying filters:', status);
  
  setParamState(filters);
};


  useEffect(() => {
    if (Object.keys(paramState).length != 0) {
      fetchData();
    }
  }, [paramState]);
  // Logger.log('paramState ======>',paramState)
  return (
    <div id="main" className="main">
      <Header />
      <section className="content-section-1">
        <div className="row">
          <div className="col-md-12">
          <ul className="nav nav-pills mb-3 content-section-1-sub-1 justify-content-around d-flex" id="pills-tab" role="tablist">
  <li onClick={() => onStatusChange("today")} className="nav-item" role="presentation">
    <button className={`nav-link ${status === "today" ? "active" : ""} px-4`} 
           id="pills-duetoday-tab" 
           data-bs-toggle="pill" 
           data-bs-target="#pills-duetoday">
      <Clock size={16} className="me-2" />
      Today ({taskTabCount?.today ? taskTabCount?.today : 0})
    </button>
  </li>
  <li onClick={() => onStatusChange("upcoming")} className="nav-item" role="presentation">  
    <button className={`nav-link ${status === "upcoming" ? "active" : ""} px-4`}
           id="pills-upcoming-tab"
           data-bs-toggle="pill" 
           data-bs-target="#pills-upcoming">
      <Calendar size={16} className="me-2" />
      Upcoming ({taskTabCount?.upcoming ? taskTabCount?.upcoming : 0})
    </button>
  </li>
  <li onClick={() => onStatusChange("overdue")} className="nav-item" role="presentation">
    <button className={`nav-link ${status === "overdue" ? "active" : ""} px-4`}
           id="pills-overdue-tab"
           data-bs-toggle="pill"
           data-bs-target="#pills-overdue">
      <AlertCircle size={16} className="me-2" />
      Overdue ({taskTabCount?.overdue ? taskTabCount?.overdue : 0})
    </button>
  </li>
  <li onClick={() => onStatusChange("completed")} className="nav-item" role="presentation">
    <button className={`nav-link ${status === "completed" ? "active" : ""} px-4`}
           id="pills-completed-tab"
           data-bs-toggle="pill"
           data-bs-target="#pills-completed">
      <CheckCircle size={16} className="me-2" />
      Done ({taskTabCount?.completed ? taskTabCount?.completed : 0})
    </button>
  </li>
  <div className="d-flex">
  <li className="me-3">
    <div className="p-2 d-flex justify-content-center" 
         style={{backgroundColor: "#EBF0F4", borderRadius: "5px", height: "34px", cursor: "pointer"}}
         onClick={toggleLeadFilterDrawer}>
      <Filter size={18} />
      <span className="ms-2">Filter</span>
    </div>
  </li>
  <li>
    <div className="p-2 d-flex justify-content-center"
         style={{backgroundColor: "#EBF0F4", borderRadius: "5px", height: "34px", cursor: "pointer"}}
         onClick={refreshTab}>
      <RotateCw size={18} />
      <span className="ms-2">Refresh</span>
    </div>
  </li>
</div>
   
</ul>

<TaskFilterStatusBar
  paramState={paramState}
  storeData={StoreData}
  onRemoveFilter={handleRemoveFilter}
  onClearAll={handleClearAllFilters}
  onEditFilter={handleEditFilter}
/>

{selectedTaskCount > 0 && (
  <div style={{ marginTop: 0, position: "relative", marginBottom: 16 }}>
    <BulkSelector
      selected={selectedTaskCount}
      onSelect={handleTaskSelection}
      onReset={handleTaskUnSelect}
    />
  </div>
)}
            <Spin size="large" tip="Loading..." spinning={isLoading}>
            <div className="tab-content" id="scrollableDiv">  
                <div
                  className="tab-pane fade show active"
                  id="pills-duetoday"
                  role="tabpanel"
                  aria-labelledby="duetoday-tab"
                >
                  
                  {/* @ts-ignore */}
                  <InfiniteScroll
  dataLength={todayTask.length}
  next={() => fetchTaskStatusOnScroll("today")}
  hasMore={todayTask.length < (taskTabCount?.today || 0) && !isLoading}
  loader={isLoading ? <h4></h4> : null}
  scrollableTarget="scrollableDiv"
  style={{ margin: 0, padding: 0 }}
>
                    <div className="followups-section-1">
                   <TaskGrid
  data={todayTask}
  isLoading={isLoading}
  handleEditTask={handleEditTask}
  selectedRowKeys={selectedTaskKeys}
  onSelectChange={handleSelectionChange}
  onLeadDetailsClick={handleLeadDetailsFromGrid}  // ADD
  onCompleteTaskClick={handleCompleteTaskFromGrid}  // ADD
  currentTab="today"  // ADD
/>
</div>
                  </InfiniteScroll>
                </div>
                <div
                  className="tab-pane fade"
                  id="pills-upcoming"
                  role="tabpanel"
                  aria-labelledby="upcoming-tab"
                >
                  {/* @ts-ignore */}
                  <InfiniteScroll
                    dataLength={upcomingTask.length}
                    next={() => fetchTaskStatusOnScroll("upcoming")}
                    hasMore={upcomingTask.length < (taskTabCount?.upcoming || 0) && !isLoading}
                    loader={isLoading ? <h4></h4> : null}
                    scrollableTarget="scrollableDiv"
                    style={{ margin: 0, padding: 0 }}
                  >
                    <div className="followups-section-1">
                 <TaskGrid
  data={upcomingTask}
  isLoading={isLoading}
  handleEditTask={handleEditTask}
  selectedRowKeys={selectedTaskKeys}
  onSelectChange={handleSelectionChange}
  onLeadDetailsClick={handleLeadDetailsFromGrid}  // ADD
  onCompleteTaskClick={handleCompleteTaskFromGrid}  // ADD
  currentTab="upcoming"  // ADD
/>
                    </div>
                  </InfiniteScroll>
                </div>
                <div
                  className="tab-pane fade"
                  id="pills-overdue"
                  role="tabpanel"
                  aria-labelledby="overdue-tab"
                >
                  {/* @ts-ignore */}
                  <InfiniteScroll
                    dataLength={overdueTask.length}
                    next={() => fetchTaskStatusOnScroll("overdue")}
                    hasMore={overdueTask.length < (taskTabCount?.overdue || 0) && !isLoading}
                    loader={isLoading ? <h4></h4> : null}
                    scrollableTarget="scrollableDiv"
                    style={{ margin: 0, padding: 0 }}
                  >
                    <div className="followups-section-1">
                  <TaskGrid
  data={overdueTask}
  isLoading={isLoading}
  handleEditTask={handleEditTask}
  selectedRowKeys={selectedTaskKeys}
  onSelectChange={handleSelectionChange}
  onLeadDetailsClick={handleLeadDetailsFromGrid}  // ADD
  onCompleteTaskClick={handleCompleteTaskFromGrid}  // ADD
  currentTab="overdue"  // ADD
/>
                    </div>
                  </InfiniteScroll>
                </div>
                <div
                  className="tab-pane fade"
                  id="pills-completed"
                  role="tabpanel"
                  aria-labelledby="completed-tab"
                >
                  {/* @ts-ignore */}
                  <InfiniteScroll
                    dataLength={completedTask.length}
                    next={() => fetchTaskStatusOnScroll("completed")}
                    hasMore={completedTask.length < (taskTabCount?.completed || 0) && !isLoading}
                    loader={isLoading ? <h4></h4> : null}
                    scrollableTarget="scrollableDiv"
                    style={{ margin: 0, padding: 0 }}
                  >
                    <div className="followups-section-1">
                 <TaskGrid
  data={completedTask}
  isLoading={isLoading}
  handleEditTask={handleEditTask}
  selectedRowKeys={selectedTaskKeys}
  onSelectChange={handleSelectionChange}
  onLeadDetailsClick={handleLeadDetailsFromGrid}  // ADD
  onCompleteTaskClick={handleCompleteTaskFromGrid}  // ADD
  currentTab="completed"  // ADD
/>
                    </div>
                  </InfiniteScroll>
                </div>
              </div>
            </Spin>

            {/* Floating Task Counter with Back to Top - only show if 15+ tasks */}
            {(() => {
              const currentData = status === "today" ? todayTask :
                                  status === "upcoming" ? upcomingTask :
                                  status === "overdue" ? overdueTask : completedTask;
              const totalCount = status === "today" ? taskTabCount?.today :
                                 status === "upcoming" ? taskTabCount?.upcoming :
                                 status === "overdue" ? taskTabCount?.overdue : taskTabCount?.completed;

              const scrollToTop = () => {
                const scrollableDiv = document.getElementById('scrollableDiv');
                if (scrollableDiv) {
                  scrollableDiv.scrollTo({ top: 0, behavior: 'smooth' });
                } else {
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                }
              };

              // Hide if less than 15 tasks OR user hasn't scrolled yet
              if (!totalCount || totalCount < 15 || !hasScrolled) return null;

              return (
                <div className="task-counter-floating">
                  <span className="task-counter-text">
                    <strong>{currentData.length}</strong> of <strong>{totalCount}</strong> tasks
                  </span>
                  {currentData.length < totalCount && (
                    <span className="task-counter-hint">Scroll for more</span>
                  )}
                  <button className="task-counter-top-btn" onClick={scrollToTop} title="Back to top">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M18 15l-6-6-6 6"/>
                    </svg>
                  </button>
                </div>
              );
            })()}

          </div>
        </div>
        <div className="row">
        {!openWithHeader && !openFilterMenu && (
    <button 
      className="add-task-button"
      onClick={handleAddTask}
    >
      <i className="bi bi-plus-circle-fill"></i>
      <span>Add Task</span>
    </button>
  )}

<TaskFormPopupWrapper
        isOpen={isTaskFormOpen}
        onClose={handleCloseTaskForm}
        action={currentTask ? 'edit' : 'add'}
        updateTaskValue={currentTask}
        fetchTaskStatusFollowUps={handleTaskStatusUpdate}
      />
  <style>{`
    .add-task-button {
      position: fixed;
      bottom: 20px;
      right: 20px;
      background: #2196F3;
      color: white;
      border: none;
      border-radius: 8px;
      padding: 8px 16px;
      display: inline-flex;
      align-items: center;
      gap: 6px;
      cursor: pointer;
      box-shadow: 0 2px 4px rgba(0,0,0,0.1);
      z-index: 1000;
      font-family: 'Gilroy', sans-serif;
      width: auto;  /* Prevent full width */
      min-width: min-content;
    }
            
            .add-task-button:hover {
              transform: translateY(-2px);
              box-shadow: 0 6px 12px rgba(0,0,0,0.15);
            }
            
            .add-task-button i {
              font-size: 20px;
            }
            
            .add-task-button span {
              font-size: 14px;
              font-weight: 500;
            }

            .task-counter-floating {
              position: fixed;
              bottom: 24px;
              left: 50%;
              transform: translateX(-50%);
              background: rgba(255, 255, 255, 0.98);
              border: 1px solid #d0d0d0;
              border-radius: 24px;
              padding: 10px 20px;
              display: flex;
              align-items: center;
              gap: 16px;
              box-shadow: 0 4px 16px rgba(0,0,0,0.12);
              z-index: 999;
              font-family: 'Gilroy', sans-serif;
              backdrop-filter: blur(10px);
            }

            .task-counter-text {
              font-size: 15px;
              font-weight: 500;
              color: #222;
            }

            .task-counter-text strong {
              font-size: 17px;
              font-weight: 700;
              color: #2196F3;
            }

            .task-counter-hint {
              font-size: 12px;
              color: #666;
              font-weight: 500;
              padding-left: 14px;
              border-left: 1px solid #d0d0d0;
            }

            .task-counter-top-btn {
              display: flex;
              align-items: center;
              justify-content: center;
              width: 32px;
              height: 32px;
              border: none;
              border-radius: 50%;
              background: #2196F3;
              color: white;
              cursor: pointer;
              transition: all 0.2s ease;
              margin-left: 4px;
            }

            .task-counter-top-btn:hover {
              background: #1976D2;
              transform: translateY(-2px);
              box-shadow: 0 4px 8px rgba(33, 150, 243, 0.3);
            }

            .task-counter-top-btn:active {
              transform: translateY(0);
            }
          `}</style>
        </div>

        
        <TaskDrawer
          openWithHeader={openWithHeader}
          setOpenWithHeader={setOpenWithHeader}
          drawerTitle={action === "add" ? "Add Task" : "Edit Task"}
          onRedirectClick={() => onClickSecondOption()}
          onTaskDelete={onTaskDelete}
          size="xs"
        >
          <CreateTaskForm
            updateTaskValue={updateTaskValue}
            action={action}
            status={status}
            drawerClose={() => setOpenWithHeader(false)}
            fetchTaskStatusFollowUps={fetchTaskStatusFollowUps}
          />
        </TaskDrawer>
       
       
      </section>
      <GlobalDrawer
        openWithHeader={openFilterMenu}
        setOpenWithHeader={setOpenFilterMenu}
        drawerTitle="Task filter"
        size="xs"
      >
        <TaskFilter
          {...{
            modal: openFilterMenu,
            toggle: () => setOpenFilterMenu(false),
            filters: paramState,
            key: `filterMenu-${filterResetKey}`,
            applyFilter: (data) => onApplyFilterClick(data),
          }}
        />
      </GlobalDrawer>

      {selectedTaskKeys.length > 0 && (
  <TaskBulkActionsBar
    selectedCount={selectedTaskKeys.length}
    onClearSelection={() => {
      setSelectedTaskKeys([]);
      setSelectedTasks([]);
      setSelectedTaskCount(0);
    }}
    onBulkAction={handleBulkAction}
    onEditStatus={onEditStatus}
    onCopyToList={() => setCopyLeadDrawer(true)}
    onAutomation={() => setAutomationDrawer(true)}
  />
)}
      <Toaster position="top-right" reverseOrder={false} />
      <LeadMenu
        leadId={leadId}
        leadLabelData={leadLabelData}
        setOpenWithHeader={setOpenWithHeader}
        selectedLead={selectedLead}
        openLeadDrawer={openLeadDrawer}
        setOpenLeadDrawer={setOpenLeadDrawer}
      />

      {/* back to top button */}
      <BackToTop />
     <GenericConfirmationModal
  showModal={showCompleteConfirmation}
  toggleModal={() => setShowCompleteConfirmation(false)}
  onConfirmation={confirmCompleteTask}
  message={`Are you sure you want to mark this task as complete for ${taskToComplete?.name}?`}
  title="Complete Task"
/>

{/* Copy Lead Drawer */}
<GlobalDrawer
  openWithHeader={copyLeadDrawer}
  setOpenWithHeader={setCopyLeadDrawer}
  drawerTitle="Copy Tasks to Lead List"
  size="sm"
>
  <div>
    <div className="mb-3">
      <label className="form-label">Select list</label>
      <select
        className="form-select"
        value={activeLeadOption}
        onChange={(e) => setActiveLeadOption(e.target.value)}
      >
        <option value="copy">Copy to list</option>
        <option value="move">Move to list</option>
      </select>
    </div>

    <label className="form-label mb-3">Select a lead list</label>
    <div>
      {leadListData?.length > 0
        ? leadListData?.map((item: any, ix: number) => {
            return (
              <button
                onClick={() => handleCopyLead(item._id, activeLeadOption)}
                key={ix}
                className="d-block bg-white w-100 p-3 rounded mb-2 border"
                style={{ margin: "8px 0px", textAlign: "left" }}
              >
                <div className="fw-bold">{item.name}</div>
              </button>
            );
          })
        : "No lead lists found"}
    </div>
  </div>
</GlobalDrawer>

{/* Automation Drawer */}
<GlobalDrawer
  openWithHeader={automationDrawer}
  setOpenWithHeader={setAutomationDrawer}
  drawerTitle="Apply Automation to Tasks"
  size="sm"
>
  <div>
    <label className="form-label mb-3">Select automation workflow</label>
    <div>
      {automationList?.length > 0
        ? automationList?.map((item: any, ix: number) => {
            return (
              <button
                onClick={() => handleSelectAutomate(item._id)}
                key={ix}
                className="d-block bg-white w-100 p-3 rounded mb-2 border"
                style={{ margin: "8px 0px", textAlign: "left" }}
              >
                <div>
                  <div className="fw-bold">{item.name}</div>
                  {item.description && (
                    <div className="text-muted small">{item.description}</div>
                  )}
                </div>
              </button>
            );
          })
        : "No automation workflows found"}
    </div>
  </div>
</GlobalDrawer>

{/* Status Components */}
<SelectLeadStatus
  showStatusPopup={showStatusPopup}
  toggleLeadStatus={toggleLeadStatus}
  onStatusChange={onLeadStatusChange}
  selectedStatus={bulkSelectedStatus}
  setShowStatusPopup={setShowStatusPopup}
  from="followups"
  leadList="followups"
  id={selectedTasks.map(task =>
    task.lead && Array.isArray(task.lead)
      ? task.lead.map(lead => lead._id).join(',')
      : ''
  ).filter(Boolean).join(',')}
  getLeads={() => fetchTaskStatusFollowUps()}
  setOpenWithHeader={() => {}}
  onLeadUpdate={() => {
    setSelectedTaskKeys([]);
    setSelectedTasks([]);
    setSelectedTaskCount(0);
    fetchTaskStatusFollowUps();
  }}
/>

    </div>
  );
};

export default FollowUps;